import React from "react";
import { Answer } from "../Answer";
import type { ConsoleCitation, ConsoleSource } from "../../api/types";
import styles from "./ChatMessageContainer.module.css";

export type ConsoleChatTurn = {
  role: "user" | "assistant";
  content: string;
  sources?: ConsoleSource[];
  citations?: ConsoleCitation[];
};

export type ChatMessageContainerProps = {
  answers: ConsoleChatTurn[];
  onCitationClicked?: (citation: ConsoleCitation) => void;
};

export function ChatMessageContainer({
  answers,
  onCitationClicked,
}: ChatMessageContainerProps) {
  return (
    <>
      {answers.map((turn, index) =>
        turn.role === "user" ? (
          <div
            key={`user-${index}`}
            className={styles.chatMessageUser}
            data-testid="console-open-trail-turn"
          >
            <div className={styles.chatMessageUserMessage} data-testid="console-open-trail-prompt">
              {turn.content}
            </div>
          </div>
        ) : (
          <div
            key={`assistant-${index}`}
            className={styles.chatMessageGpt}
            data-testid="console-open-trail-answer"
          >
            <Answer
              answer={turn.content}
              sources={turn.sources || []}
              citations={turn.citations}
              onCitationClicked={onCitationClicked}
            />
          </div>
        ),
      )}
    </>
  );
}
